import axios from "axios";
const instance = axios.create({ baseURL: "https://hyc.ondemandcrm.co"}); //window.location.origin//
export default instance;
